<template>
  <div>
    <div
      v-if="loading"
      id="carregaDados"
      :style="styleObject"
    >
      <v-icon
        light
        :style="styleObject"
        class="custom-loader"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div style="margin: 0 0 0 -3rem">
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            id="valorDevolucao"
            class="text-right"
            :style="styleObjectDevolucao"
          >
            {{ devolucaoImpropria }}
          </div>
        </v-col>
      </v-row>
      <canvas
        id="devolucaoImpropria"
        class="text-center"
        width="70"
        height="50"
      />
      <!-- <span
        v-if="title"
        id="tituloDevolucaoImpropria"
        class="text-center"
        :style="styleObjectDevolucao"
      >{{ title }}</span> -->
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Comercial from '../../../../services/comercial'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardPie3',
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectDevolucao: {
        color: '#C62828',
      },
      title: '',
      myChart: {},
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      vendedor: [],
      rede: [],
      categoria: [],
      promotor: [],
      text: null,
      montarGrafico: true,
      loading: false,
      error: null,
      devolucaoImpropria: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    }),

    created () {
      eventEmit.$on('update-datas', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-datas', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita, vendedor, rede, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.dataFinal = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.vendedor = vendedor
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true
        this.devolucaoImpropria = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.title = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Comercial.showDevolucaoImpropria(this.primeiroDia, this.dataFinal, this.select, this.supervisor, this.receita, localStorage.tokencontrato, [], [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.devolucaoImpropria = resposta.data.devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const devolucao = resposta.data.porcentagem
            const faturamento = 100 - resposta.data.porcentagem

            this.title = resposta.data.porcentagem.toFixed(2).toString().replace('.', ',') + '%'

            const ctx = document.getElementById('devolucaoImpropria').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Devolucao Imprópria', 'Faturmento'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [devolucao, faturamento],
                    backgroundColor: [
                      '#C62828',
                      '#FFEBEE',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 65,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.title,
                    color: '#C62828',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.title = '0,0 %'
            this.text = resposta.data.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #devolucaoImpropria {
      margin: -0.6rem 0 0 2.6rem;
      width: 80px !important;
      height: 57px !important;
    }

    #valorDevolucao {
      font-size: 14px;
      display: grid;
      align-items: center;
      font-weight: bold;
      /* margin: 2rem 0 0 3rem; */
    }

    #tituloDevolucaoImpropria {
      font-size: 12px;
      margin: -1.3rem 0 0 2.5rem;
      display: grid;
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #devolucaoImpropria {
      font-size: 20px;
      margin: -0.6rem 0 0 12rem;
      display: grid;
    }

    #tituloDevolucaoImpropria {
      font-size: 12px;
      margin: -2rem 0 0 0.5rem;
      display: grid;
    }
  }

  @media screen and (min-width: 1380px) and (max-width: 1650px) {
    #devolucaoImpropria {
      margin: -1rem 0 3rem 14rem;
    }

    #valorDevolucao {
      margin: 0 0 0 -3rem;
    }

    #tituloDevolucaoImpropria {
      margin: -5rem 0 3rem 14rem;
    }
  }

  @media screen
  and (min-width: 1651px) {
    #devolucaoImpropria {
      margin: -1.5rem 0 0rem 6rem;
    }

    #valorDevolucao {
      margin: -1rem 0 0 -3rem;
    }

    #tituloDevolucaoImpropria {
      margin: -2rem 0 -1rem 5.5rem;
    }
  }
</style>

<style lang="sass">
  #devolucaoImpropria
    font-size: 20px
    margin: -0.6rem 0 0 10rem
    display: grid
    width: 110px !important
    height: 73px !important

  #tituloDevolucaoImpropria
    font-size: 16px
    display: grid
    align-items: center
    margin: -2rem 0 0 6rem

  #valorDevolucao
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
</style>
